module.exports = {"name":"cardNotifications","audiences":["alphaMembers","allMembers"],"experimentAllocation":{"alphaMembers":1,"allMembers":0.2},"experimentVersion":"v2","defaultWeight":1,"defaults":{"showCards":false},"variations":[{"name":"showCards","weight":1,"values":{"showCards":true}}],"autoTrack":true}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/lib/experiments/config/cardNotifications.json
// module id = 3GOo
// module chunks = 2